import { gql } from "@apollo/client";
import { print } from "@apollo/client/utilities";

export const DELETE_QUERY = print(gql`
  mutation DeletePartnerCompany($id: Int!) {
    deletePartnerCompany(id: $id) {
      id
    }
  }
`);

export interface DeleteGql {
  deletePartnerCompany: {
    id?: number;
  };
}
